import React, {useEffect, useState} from 'react';
import TitleBar from "../../components/popUp/TitleBar";
import ChartTitle from "../../components/charts/ChartTitle";
import {Card, Col, Row} from "react-bootstrap";
import CardView from "../../components/layout/CardView";
import {getMapCards, getMapCardsAnon} from "../../api/apiClient";

const FailureCards = ({
                        propAtdrcId = '',
                        propAnonAPI = false
                      }) => {

  const [cardData, setCardData] = useState();

  const [stTimeRefresher, setTimeRefresher] = useState(null);
  const [stRefreshSeed, setRefreshSeed] = useState(0);

  useEffect(() => {
    updateData();

    let timeInterval = setInterval(updateCycle, 10000);
    setTimeRefresher(timeInterval);

    return () => {
      console.log("unmount");
      console.log(stTimeRefresher)
      clearInterval(stTimeRefresher);
    };

  }, [])

  useEffect(() => {
    updateData();
  }, [stRefreshSeed, propAtdrcId])

  const updateCycle = () => {
    let rand = Math.random();
    console.log(`update 10s! ${rand}`);
    setRefreshSeed(rand);
    // updateCardList();
    // updateLabelList();
    // updateBackButton();
    // updateMarker();
  }

  const updateData = () => {
    let atdrcId = ''
    if (propAtdrcId != '0') {
      atdrcId = propAtdrcId
    }

    if (propAnonAPI) {
      getMapCardsAnon(atdrcId).then(res => {
        console.log(res);
        setCardData(res.data.data);
      })
    } else {
      getMapCards(atdrcId).then(res => {
        console.log(res);
        setCardData(res.data.data);
      })
    }
  }

  useEffect(() => {
    console.log(cardData);
  }, [cardData]);


  return (
      <div className={`content-container ${propAnonAPI ? "status" : ''}`}>
        {/*<TitleBar title={"장애 및 성능"}/>*/}
        <div className={"content-container-body"}>

          {/* 화재 발생 현황 */}
          <div className={`content-container-body-item fire m-2 px-2`}
              // style={{height: '497px', overflow: 'auto'}}
          >
            {/*<ChartTitle title={"화재 발생 현황"}/>*/}
            <TitleBar title={`화재 발생 현황`}/>
            {cardData?.fireList.map((elem, idx) => {
              /*if (cardData.fireList.length === 0) {
                return <Card
                    bg={'dark'}
                    key={'dark'}
                    border="light"
                    className={"mb-2"}
                >
                  <Card.Body className={'text-center my-5 py-5'}>
                    <div className={"fs-3 mt-5"}
                         style={{marginBottom: '2rem'}}
                    >
                      최근 30일
                    </div>
                    <div className={"mb-1"}></div>
                    <div className={"fs-2 fw-bold"}
                         style={{marginBottom: '2.3rem'}}
                    >
                      화재발생 없음
                    </div>
                  </Card.Body>
                </Card>;
              } else if (cardData.fireList.length === 1) {
                if (idx < 1) {
                  return <CardView
                      key={idx}
                      propType={"fire"}
                      propLevel={'crit'}
                      // propText={elem.ocrn_dt_str}
                      propDate={elem.ocrn_dt_str}
                      propText2={`${elem.fclty_nm} ${elem.fire_sttus_nm}`}
                      propLength={cardData.fireList.length}
                  />;
                }
              } else if (cardData.fireList.length === 2) {
                if (idx < 2) {
                  return <CardView
                      key={idx}
                      propType={"fire"}
                      propLevel={'crit'}
                      // propText={elem.ocrn_dt_str}
                      propDate={elem.ocrn_dt_str}
                      propText2={`${elem.fclty_nm} ${elem.fire_sttus_nm}`}
                      propLength={cardData.fireList.length}
                  />;
                }
              } else if (cardData.fireList.length === 3) {
                if (idx < 3) {
                  return <CardView
                      key={idx}
                      propType={"fire"}
                      propLevel={'crit'}
                      // propText={elem.ocrn_dt_str}
                      propDate={elem.ocrn_dt_str}
                      propText2={`${elem.fclty_nm} ${elem.fire_sttus_nm}`}
                      propLength={cardData.fireList.length}
                  />
                }
              }*/

              if (idx < 2) {
                return <CardView
                    key={idx}
                    propType={"fire"}
                    propLevel={'crit'}
                    // propText={elem.ocrn_dt_str}
                    propDate={elem.ocrn_dt_str ? elem.ocrn_dt_str : "최근 30일"}
                    propText2={`${elem.fclty_nm}`}
                    propLength={cardData.fireList.length}
                />;
              }
              return;
            })}

            {/*{!cardData?.fireList ? <CardView/> : null}*/}
            {cardData?.fireList.length === 0 ? (
                <Card
                    bg={'dark'}
                    key={'dark'}
                    border="light"
                    className={"mb-2"}
                >
                  <Card.Body className={'text-center'}>
                    <div className={"fs-3 mt-5"}
                         style={{marginBottom: '2.5rem'}}
                    >
                      최근 30일
                    </div>
                    <div className={"fs-2 fw-bold"}
                         style={{marginBottom: '2.5rem'}}
                    >
                      화재발생 없음
                    </div>
                  </Card.Body>
                </Card>
            ) : null}

          </div>

          {/* 누적 장애 현황 */}
          <div className={"content-container-body-item m-2 px-2"}>
            <TitleBar title={"누적 장애 현황"}/>
            <Row>
              <Col>
                <CardView
                    propType={"fault"}
                    // propLevel={'crit'}
                    propText={'Critical'}
                    propText2={`${cardData?.faultSumList[0]?.cr ? cardData?.faultSumList[0]?.cr : '0'}`}
                    propLineBreak={true}
                />
              </Col>
              <Col>
                <CardView
                    propType={"fault"}
                    // propLevel={'major'}
                    propText={'Major'}
                    propText2={`${cardData?.faultSumList[0]?.mj ? cardData?.faultSumList[0]?.mj : '0'}`}
                    propLineBreak={true}
                />
              </Col>
              <Col>
                <CardView
                    propType={"fault"}
                    // propLevel={'minor'}
                    propText={'Minor'}
                    propText2={`${cardData?.faultSumList[0]?.mn ? cardData?.faultSumList[0]?.mn : '0'}`}
                    propLineBreak={true}
                />
              </Col>
            </Row>
          </div>

          {/* 일일 장애 현황 */}
          <div className={"content-container-body-item m-2 px-2"}>
            {/*<ChartTitle title={"일일 장애 현황"}/>*/}
            <TitleBar title={"일일 장애 현황"}/>
            <Row>
              <Col>
                <CardView
                    propType={"fault"}
                    // propLevel={'crit'}
                    propText={'Critical'}
                    propText2={`${cardData?.faultList[0]?.cr ? cardData?.faultList[0]?.cr : '0'}`}
                    propLineBreak={true}
                />
              </Col>
              <Col>
                <CardView
                    propType={"fault"}
                    // propLevel={'major'}
                    propText={'Major'}
                    propText2={`${cardData?.faultList[0]?.mj ? cardData?.faultList[0]?.mj : '0'}`}
                    propLineBreak={true}
                />
              </Col>
              <Col>
                <CardView
                    propType={"fault"}
                    // propLevel={'minor'}
                    propText={'Minor'}
                    propText2={`${cardData?.faultList[0]?.mn ? cardData?.faultList[0]?.mn : '0'}`}
                    propLineBreak={true}
                />
              </Col>
            </Row>
          </div>
        </div>
      </div>
  );
};

export default FailureCards;